import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const driverStatusTypesAdapter = getAdapter({ idFieldName: 'text' });

const driverStatusTypesSlice = createSlice({
  name: 'driverStatusTypes',
  initialState: driverStatusTypesAdapter.getInitialState(),
  reducers: {
    setDriverStatusTypes: (state, { payload: { driverStatusTypes } }) => {
      driverStatusTypesAdapter.setAll(state, driverStatusTypes);
    },
  },
});

const selectors = driverStatusTypesAdapter.getSelectors(({ driverStatusTypes }) => driverStatusTypes);

export const getDriverStatusTypes = (state) => selectors.selectAll(state);

export const { setDriverStatusTypes } = driverStatusTypesSlice.actions;

export default driverStatusTypesSlice.reducer;
